<template>
  <div class="d-flex align-items-center">
    <b-avatar
      rounded
      :size="avatarSize"
      variant="light-primary"
      class="mr-1"
    >
      <feather-icon
        :icon="icon"
        :size="iconSize"
      />

    </b-avatar>
    <div>
      <h4 class="mb-0">
        {{ title }}
      </h4>
      <small>{{ subtitle }}</small>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
  },
  props: {
    title: {
      type: String,
      // required: true,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'InfoIcon',
    },
    iconSize: {
      type: String,
      default: '20',
    },
    avatarSize: {
      type: String,
      default: '40',
    },
  },
}
</script>
